"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoneScreen = void 0;
var SecuredByQwilr_1 = require("@CommonFrontend/SecuredByQwilr/SecuredByQwilr");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var pages_common_1 = require("@qwilr/pages-common");
var react_1 = __importDefault(require("react"));
var AcceptFlowContextProvider_1 = require("../AcceptFlowContextProvider");
var SecuredByQwilr_2 = require("../Utils/SecuredByQwilr");
var AcceptFlowSparkles_1 = require("./DoneComponents/AcceptFlowSparkles");
var DownloadAuditTrailButton_1 = require("./DoneComponents/DownloadAuditTrailButton");
var AuthenticationContext_1 = require("@CommonFrontend/Public/Identity/AuthenticationContext");
var styles = __importStar(require("./DoneScreen.css"));
var classnames_1 = __importDefault(require("classnames"));
var partiallyAcceptedText = "Congratulations! You have accepted the page. Once everyone has accepted this project, you’ll receive a PDF record of this document.";
var fullyAcceptedText = "Congratulations! The page has been accepted. A signed PDF copy has been emailed to you.";
var DoneScreen = function (_a) {
    var onClose = _a.onClose;
    var _b = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), text = _b.text, incompleteAccepterCount = _b.incompleteAccepterCount;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", gap: "l" },
        react_1.default.createElement(AcceptFlowSparkles_1.AcceptFlowSparkles, null),
        react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", align: "center" }, "Accepted"),
        react_1.default.createElement(kaleidoscope_1.Text, { align: "center" }, !!text.doneState ? text.doneState : incompleteAccepterCount > 0 ? partiallyAcceptedText : fullyAcceptedText),
        react_1.default.createElement(DoneStateComponent, { onClose: onClose }),
        react_1.default.createElement(SecuredByQwilr_1.SecuredByQwilr, { utmParams: SecuredByQwilr_2.acceptFlowMarketingParams })));
};
exports.DoneScreen = DoneScreen;
var DoneStateComponent = function (_a) {
    var onClose = _a.onClose;
    var _b = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), postAcceptance = _b.postAcceptance, optOutSpringboard = _b.optOutSpringboard;
    var isSignedIn = (0, pages_common_1.useAuthenticationContext)().isSignedIn;
    if (postAcceptance) {
        return react_1.default.createElement(PostAcceptRedirect, null);
    }
    if (optOutSpringboard) {
        return react_1.default.createElement(Generic, { onClose: onClose });
    }
    if (isSignedIn) {
        return react_1.default.createElement(SpringboardDoneState, { onClose: onClose });
    }
    return react_1.default.createElement(SpringboardSignupPrompt, { onClose: onClose });
};
var PostAcceptRedirect = function () {
    var _a = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), postAcceptance = _a.postAcceptance, auditTrailPdfUrl = _a.auditTrailPdfUrl, isPreviewAccept = _a.isPreviewAccept;
    var showDownload = isPreviewAccept || !!auditTrailPdfUrl;
    if (!postAcceptance) {
        return null;
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", gap: "s" },
        showDownload && react_1.default.createElement(DownloadAuditTrailButton_1.DownloadAuditTrailButton, null),
        react_1.default.createElement(kaleidoscope_1.Button, { width: "full", size: kaleidoscope_1.ButtonSize.Large, onClick: function () {
                window.location.href = postAcceptance.url;
            } }, postAcceptance.actionLabel ? postAcceptance.actionLabel : "Continue")));
};
var SpringboardSignupPrompt = function (_a) {
    var onClose = _a.onClose;
    var _b = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), isPreviewAccept = _b.isPreviewAccept, telemetry = _b.telemetry;
    var getAuthUrl = (0, AuthenticationContext_1.useAuthenticationContext)().getAuthUrl;
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: (0, classnames_1.default)("kl-opt-in-lowercase-button", styles.ctaTextOverrides) },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", padding: "l", justify: "center" },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", justify: "center" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", strong: true, align: "center" }, "Save a copy of your document"),
                react_1.default.createElement(kaleidoscope_1.Text, { align: "center", size: "s" }, "Sign up for a free Qwilr Springboard account to save a digital record of your document")),
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s", direction: "horizontal", justify: "center" },
                react_1.default.createElement(kaleidoscope_1.Button, { onClick: onClose, type: kaleidoscope_1.ButtonType.Secondary }, "No thanks"),
                react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (content) {
                        if (isPreviewAccept) {
                            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, wrapTarget: true, content: "Your clients can save a digital copy of the accepted page" }, content));
                        }
                    } },
                    react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                            window.localStorage.setItem(pages_common_1.ACTION_SPRINGBOARD_DISCOVERY_LOCALSTORAGE_KEY, "true");
                            telemetry.track("Clicked Post-Accept Springboard Signup", {});
                            window.open(getAuthUrl("signup", encodeURIComponent(window.location.href), AuthenticationContext_1.AuthenticationOrigin.PostAcceptFlow));
                        }, disabled: isPreviewAccept }, "Save document"))))));
};
var SpringboardDoneState = function (_a) {
    var onClose = _a.onClose;
    var getSpringboardUrl = (0, pages_common_1.useSpringboardContext)().getSpringboardUrl;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Button, { width: "full", size: kaleidoscope_1.ButtonSize.Large, type: kaleidoscope_1.ButtonType.Secondary, href: function () { return getSpringboardUrl("accepted", pages_common_1.SpringboardAppOrigin.PostAcceptSignedInNotification); }, className: styles.springboardCta }, "View in Springboard"),
        react_1.default.createElement(kaleidoscope_1.Button, { width: "full", size: kaleidoscope_1.ButtonSize.Large, onClick: onClose }, "Done")));
};
var Generic = function (_a) {
    var onClose = _a.onClose;
    var _b = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), auditTrailPdfUrl = _b.auditTrailPdfUrl, isPreviewAccept = _b.isPreviewAccept;
    var showDownload = isPreviewAccept || !!auditTrailPdfUrl;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", gap: "s" },
        showDownload && react_1.default.createElement(DownloadAuditTrailButton_1.DownloadAuditTrailButton, null),
        react_1.default.createElement(kaleidoscope_1.Button, { width: "full", size: kaleidoscope_1.ButtonSize.Large, onClick: onClose }, "Done")));
};
